import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DetallesPrestacionService {
  constructor(private http: HttpClient) {}

  getPrestadorActivo(cuit): Observable<any> {
    return this.http.post(`${environment.urlApi}discapacidad/aPrestadorActivo`, cuit);
  }

  descargarArchivo(data): Observable<any> {
    return this.http.post(`${environment.urlApi}discapacidad/downloadPrestacionFile`, data);
  }

  getDetallePrestacion(data: any): Observable<any> {
    const body = {
      sessionId: data.sessionId,
      nroBeneficiario: data.benNroAse,
      nroOrden: data.benNroOrden,
      secuencia: data.discaTramSec,
      anio: data.anio
    };
    return this.http.post(`${environment.urlApi}discapacidad/getDetalle/Prestacion`, body);
  }
}
